import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { AuthComponent } from './auth.component';
import { AuthRoutingModule } from './auth-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { OtpSetupComponent } from './otp-setup/otp-setup.component';
import { AutoFocusInputDirective, FormControlComponent, IconComponent, ModalBaseContainerComponent, SliderComponent } from '@frogo-kit/core';

@NgModule({
  declarations: [LoginComponent, AuthComponent, OtpSetupComponent],
  imports: [
    CommonModule,
    AuthRoutingModule,
    NgOptimizedImage,
    TranslateModule,
    HttpClientModule,
    ReactiveFormsModule,

    IconComponent,
    FormControlComponent,
    ModalBaseContainerComponent,
    SliderComponent,
    AutoFocusInputDirective,
  ],
})
export class AuthModule {}
